import API from '.';

export default class Timezone {
  /**
   * The Timezone dimension table for UDM
   * @param {number} timezoneId Id of the timezone.
   * @param {string} timezoneName UTC value of the timezone.
   * @param {string} timezoneDesc Description of the timezone.
   */
  constructor({ timezoneId, timezoneName, timezoneDesc }) {
    this.timezoneId = timezoneId;
    this.timezoneName = timezoneName;
    this.timezoneDesc = timezoneDesc;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/timezone');
    return data.map((d) => new Timezone(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`timezone/${id}`);
    return new Timezone(data);
  }
}
